// URL に日時を JST (+09:00) 形式で載せるべきルートの path 一覧。
// src/config/router.ts の beforeEach guard と src/utils/url/index.ts の urlWithGlobalParams で参照される。
export const JST_URL_ROUTES: string[] = ['/costs', '/allocation'];
